import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  TextField,
  Button,
  Grid,
  Link,
  Card,
  CardContent
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import {
  resetVerifyEmailState,
  verifyEmailRequest
} from "../../redux/auth/actions/authActions";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useForm, Controller } from "react-hook-form";
import AirplanemodeActiveIcon from "@mui/icons-material/AirplanemodeActive";
import AtithiLogo from "../../assets/Atithiseva-Logo-Final-1024x298.png";
import { useNavigate } from "react-router-dom";
import "../../styles/VerifyEmail.css";
import { LOGIN } from "../../component/common/Routes/AppRoutes";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import CustomButton from "../../component/ui/FormFields/Button";
export default function VerifyOTP() {
  const { control, handleSubmit, clearErrors } = useForm({
    defaultValues: {
      code: ["", "", "", "", "", ""]
    }
  });
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const email = localStorage.getItem("userEmail");
  const { loading, success, error } = useSelector(
    (state) => state.verifyEmailReducer
  );
  useEffect(() => {
    if (email) {
      localStorage.setItem("email", email);
      dispatch({
        type: "FORGOT_PASSWORD_REQUEST",
        payload: { email: email }
      });
    }
  }, [email]);
  const [timer, setTimer] = useState(60);
  const [isResendDisabled, setIsResendDisabled] = useState(true);
  const [timerId, setTimerId] = useState(null);

  useEffect(() => {
    if (timer > 0) {
      const id = setTimeout(() => setTimer(timer - 1), 1000);
      setTimerId(id);
      return () => clearTimeout(id);
    } else {
      setIsResendDisabled(false);
    }
  }, [timer]);

  const stopTimer = () => {
    if (timerId) clearTimeout(timerId);
    setTimer(0);
    setIsResendDisabled(false);
  };

  const onSubmitForm = (data) => {
    if (loading) return;
    const enteredCode = data.code.join("");
    dispatch(verifyEmailRequest({ email, verification_code: enteredCode }));
  };
  useEffect(() => {
    if (success) {
      toast.success("OTP Verified Successfully!", {
        position: "top-center",
        autoClose: 3000,
        onClose: () => {
          dispatch(resetVerifyEmailState());
          navigate(LOGIN);
          stopTimer();
        }
      });
    }
  }, [success, email]);
  useEffect(() => {
    if (error) {
      toast.error("Enter Correct OTP", {
        position: "top-center",
        autoClose: 3000,
        onClose: () => {
          stopTimer();
        }
      });
      dispatch(resetVerifyEmailState());
    }
  }, [error]);

  useEffect(() => {
    toast.success("OTP sent successfully");
  }, []);

  useEffect(() => {
    dispatch(resetVerifyEmailState());
  }, []);

  const handleInputChange = (e, index, field) => {
    const updatedCode = [...field.value];
    const value = e.target.value;
    const isBackspace = e.nativeEvent.inputType === "deleteContentBackward";

    if (isBackspace) {
      if (index > 0 && !updatedCode[index]) {
        updatedCode[index - 1] = "";
        document.getElementById(`code-${index - 1}`).focus();
      } else {
        updatedCode[index] = "";
      }
    } else if (value.match(/^[0-9]$/)) {
      updatedCode[index] = value;
      if (index < updatedCode.length - 1) {
        document.getElementById(`code-${index + 1}`).focus();
      }
    }

    field.onChange(updatedCode);

    if (field.error) clearErrors("code");
  };

  const handleResendCode = () => {
    dispatch({
      type: "FORGOT_PASSWORD_REQUEST",
      payload: { email: email }
    });
    toast.success("A new verification code has been sent to your email.");
    setTimer(60);
    setIsResendDisabled(true);
  };

  return (
    <>
      <ToastContainer position="top-center" autoClose={5000} />
      <Box className="verify-email-container">
        <Box className="airplane-icon-position">
          <AirplanemodeActiveIcon
            sx={{
              fontSize: { xs: 100, sm: 150, md: 200 },
              color: "#C62828",
              opacity: 0.1
            }}
          />
        </Box>

        <Card
          sx={{
            maxWidth: { xs: 320, sm: 400 },
            width: "100%",
            borderRadius: 4,
            boxShadow: 3,
            zIndex: 2,
            padding: { xs: 3, sm: 5 }
          }}
        >
          <CardContent>
            <Box sx={{ textAlign: "center" }}>
              <img
                src={AtithiLogo}
                alt="Atithiseva Logo"
                style={{ maxWidth: "150px", marginBottom: "10px" }}
              />
            </Box>
            <Box sx={{ textAlign: "center", mb: 3 }}>
              <Typography
                variant="h6"
                fontWeight="bold"
                sx={{ color: "#E31E24", fontSize: { xs: "18px", sm: "20px" } }}
              >
                Verify Your Email Address
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  color: "#757575",
                  mt: 1,
                  fontSize: { xs: "12px", sm: "14px" }
                }}
              >
                Enter the 6-digit verification code sent to your email address.
              </Typography>
            </Box>

            <form onSubmit={handleSubmit(onSubmitForm)}>
              <Controller
                name="code"
                control={control}
                rules={{
                  validate: (value) =>
                    value.join("").length === 6 || "Please fill all fields"
                }}
                render={({ field, fieldState }) => (
                  <>
                    <Grid
                      container
                      spacing={5}
                      justifyContent="center"
                      sx={{ mb: 2 }}
                    >
                      {field.value.map((digit, index) => (
                        <Grid item xs={2} key={index}>
                          <TextField
                            id={`code-${index}`}
                            value={digit}
                            onChange={(e) => handleInputChange(e, index, field)}
                            onKeyDown={(e) => {
                              if (
                                e.key === "Backspace" &&
                                !digit &&
                                index > 0
                              ) {
                                document
                                  .getElementById(`code-${index - 1}`)
                                  .focus();
                              }
                            }}
                            variant="outlined"
                            inputProps={{
                              maxLength: 1,
                              style: { textAlign: "center", fontSize: "18px" }
                            }}
                            sx={{
                              "& .MuiOutlinedInput-root": {
                                borderRadius: "8px",
                                height: { xs: "40px", sm: "40px" },
                                width: { xs: "40px", sm: "40px" }
                              }
                            }}
                            error={!!fieldState.error}
                          />
                        </Grid>
                      ))}
                    </Grid>

                    {fieldState.error && (
                      <Typography
                        variant="body2"
                        color="error"
                        sx={{ textAlign: "center", mb: 2 }}
                      >
                        {fieldState.error.message}
                      </Typography>
                    )}
                  </>
                )}
              />
              <CustomButton
                variant="contained"
                className="verify-email-btn"
                type="submit"
                size="large"
                fullwidth={true}
                loading={loading}
                text={"Verify OTP"}
              />

              <Typography
                variant="body2"
                color="text.secondary"
                sx={{
                  textAlign: "center",
                  mt: 2,
                  fontSize: { xs: "12px", sm: "14px" }
                }}
              >
                <Link
                  href="#"
                  underline="hover"
                  sx={{
                    fontWeight: "bold",
                    color: isResendDisabled ? "gray" : "#E31E24",
                    pointerEvents: isResendDisabled ? "none" : "auto"
                  }}
                  onClick={handleResendCode}
                >
                  {isResendDisabled
                    ? `Resend Code in ${timer}s`
                    : "Resend Code"}
                </Link>
              </Typography>
            </form>
          </CardContent>
        </Card>
      </Box>
    </>
  );
}
